import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';

export type Login = {
    id: string;
    name: string;
    email: string;
    image: string;
};

type LoginState = {
    login: Login;
};

const initialState: LoginState = {
    login: {
        id: '',
        name: '',
        email: '',
        image: '',
    },
};

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        setLogin(state: LoginState, action: PayloadAction<Login>) {
            state.login = action.payload;
        },
    },
});

// Selectors
export const selectLogin = (state: RootState) => state.login.login;

// Actions
export const { setLogin } = loginSlice.actions;

// It is a convention to export reducer as a default export:
export default loginSlice.reducer;
